import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account/'
import ads from './modules/ads'
import adCreatives from './modules/adCreatives'
import adPreview from './modules/adPreview'
import analytics from './modules/analytics'
import app from './modules/app/'
import audience from './modules/audience'
import auth from './modules/auth/'
import blockingPrefs from './modules/blockingPrefs/'
import campaigns from './modules/campaigns/'
import categories from './modules/categories/'
import episodes from './modules/episodes'
import feeds from './modules/feeds'
import markers from './modules/markers/'
import podcasts from './modules/podcasts/'
import promos from './modules/promos/'
import teams from './modules/teams'
import websockets from './modules/websockets'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    ads,
    adCreatives,
    adPreview,
    analytics,
    app,
    audience,
    auth,
    blockingPrefs,
    campaigns,
    categories,
    episodes,
    feeds,
    markers,
    podcasts,
    promos,
    teams,
    websockets
  }
})
